import {
    oneOfType,
    bool,
    shape,
    string,
    number,
    objectOf,
    any,
} from 'prop-types';

export default shape({
    configure: shape({
        page: number,
        offset: number,
    }),
    refinementList: objectOf(any),
    range: objectOf(shape({ min: number, max: number })),
    menu: objectOf(oneOfType([string, number])),
    toggle: objectOf(bool),
    hitsPerPage: number,
    sortBy: string,
    query: string,
    manomano: shape({
        tagetOffset: number,
        urlParams: shape({ q: string }),
    }),
});
